import requestUtils from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-svc-merchandise'

type Response = paths['/api/merchandise/brands']['get']['responses']['200']['content']['application/json']

function getMerchandiseBrands(): Promise<Array<App.MerchandiseBrand>> {
  return requestUtils.get<Response>('/api/merchandise/brands').then((response) => {
    return response.result.brands.map((serverBrand) => ({
      id: serverBrand.id,
      name: serverBrand.name,
      slug: serverBrand.slug,
      logo: serverBrand.logoId ? {
        id: serverBrand.logoId,
      } : undefined,
    }))
  })
}

export default getMerchandiseBrands
